import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardActions, CardContent, Checkbox, Container, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Icon, IconButton, InputLabel, MenuItem, Modal, Paper, Radio, RadioGroup, Select, SelectChangeEvent, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { themePalette } from "../../config/theme.config";
import { FaCaretDown, FaCaretLeft, FaCaretRight, FaCaretUp, FaCheck, FaEdit, FaEye, FaEyeSlash, FaInfo, FaInfoCircle, FaPlus, FaPlusCircle, FaQuestionCircle, FaTrash, FaUpload } from "react-icons/fa";
import { useEffect, useState } from "react";
import { Pagina } from "../../types/Plantillas/Pagina";
import { Plantilla} from "../../types/Plantillas/Plantilla";
import ParametroList from "../../componente/Plantillas/ParametroList";
import NotificationShow from "../../componente/Plantillas/NotificationShow";
import { Parametro } from "../../types/Plantillas/Parametro";
import PlantillaService from "../../services/PlantillaService";
import { useAppSelector } from "../../redux/hooks";

export const PlantillasPage: React.FC<{}> = () => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [fileName, setFileName] = useState<string | null>(null);
    const [url, setUrl] = useState<string | null>(null);
    const [urlVer, setUrlVer] = useState<string | null>(null);
    const [urlRec, setUrlRec] = useState<string | null>(null);
    const [urlImg, setUrlImg] = useState<string | null>(null);
    const [baseString, setBaseString] = useState<string | null>(null);
    const [page, setPage] = useState('');
    const [step, setStep] = useState(0);
    const [desc, setDesc] = useState<string | null>(null);
    const [title, setTitle] = useState<string | null>(null);
    const [content, setContent] = useState<string | null>(null);
    const [replacedContent, setReplacedContent] = useState<string | null>(null);
    const [action, setAction] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [justLook, setJustLook] = useState(false);
    const [justEditing, setJustEditing] = useState(false);
    const [justCreating, setJustCreating] = useState(false);
    const [newImage, setNewImage] = useState(false);
    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(true);
    const [showJson, setShowJson] = useState(false);
    const [showJsonButton, setShowJsonButton] = useState(false);
    const [errors, setErrors] = useState({ title: false, content: false, desc: false, page: false, showModal: false, action: false, url: false });
    const [pages, setPages] = useState<Pagina[]>([]);
    const [rows, setRows] = useState<any[]>([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const {isAuth, userData} = useAppSelector((state) => state.authReducer)
    const [jsonData, setJsonData] = useState<any | null>(null);
    const [jsonParams, setJsonParams] = useState<{ [key: string]: string }>({});
    
    
    const handleChangePage = (event: unknown, newPage: number) => {
      setPageNumber(newPage);
    };
    
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPageNumber(0);
    };

    const [editedPlantilla, setEditedPlantilla] = useState<Plantilla>(
      new Plantilla(
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          false,
          '',
          ''
      )
    );
    // Initialize and make Plantilla settable
    const [plantilla, setPlantilla] = useState<Plantilla>(
      new Plantilla(
          '',
          '',
          'Bienvenida',
          'Este es el contenido de bienvenida',
          'Descripción de bienvenida',
          'Home',
          '',
          '',
          true,
          'webPage',
          'https://example.com'
      )
    );

    // Update an existing Parametro
    const updateParametro = (nombre: string, updatedEjemplo: string) => {
      setJsonParams(prev => ({
        ...prev,
        [nombre]: updatedEjemplo
      }));
    };

    const validateBasicConfig = () => {
      const newErrors = {
        title: !title || title.trim() === '',
        content: !content || content.trim() === '',
        desc: !desc || desc.trim() === '',
      };

      console.log(newErrors);
      
      setErrors((prevErrors) => ({
        ...prevErrors,
        ...newErrors
      }));
      
      // Return true if no errors, false otherwise
      return Object.values(newErrors).every((error) => !error);
    };

    const validateReglasPres = () => {
      const newErrors = {
        showModal: showModal === null,
        action: false,
        url: false,
      };

      if(action != ''){
        newErrors.url = url == '';
      }

      // if(action ){
        
      // }

      console.log(newErrors);
      
      setErrors((prevErrors) => ({
        ...prevErrors,
        ...newErrors
      }));
      
      
      return Object.values(newErrors).every((error) => !error);
    };

    const validateField = (field: string, value: string) => {
      if(!justLook){
        setErrors((prev) => ({
          ...prev,
          [field]: value.trim() === ''
        }));
      }
    };

    const handleChange = (event: SelectChangeEvent) => {
      if(justEditing){
        editedPlantilla?.setPaginaDestino(event.target.value as string);
      }
      setPage(event.target.value as string);
    };



    const handleChangeAction = (event: SelectChangeEvent) => {
      if(justEditing){
        editedPlantilla?.setAccion(event.target.value as string);
      }
      setAction(event.target.value as string);
    };


    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        const imageURL = URL.createObjectURL(file);
    
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result as string; 
          const base64WithoutPrefix = base64String.split(',')[1]; 

          setBaseString(base64WithoutPrefix);
          console.log(base64WithoutPrefix); 

          if (justEditing) {
            editedPlantilla?.setNombreImagen(file.name);
            editedPlantilla?.setUrlImagen(imageURL);
            setNewImage(true);
          }
          setFileName(file.name);
          setUrlImg(imageURL);
          setNewImage(true);
        };

      }
    };

    const checkContentVariables = () => {
      const replacePatterns = (input: string | null, jsonParam: { [key: string]: string }) => {
        if (input != null) {
          return input.replace(/\{\{(\w+)\}\}/g, (_match, key) => {
            console.log("clave modificada "+ _match + " | " + key);
            return jsonParam[key] ?? ''; // fallback to empty string if key is missing
          });
        } else {
          return '';
        }
      };
    
      setReplacedContent(replacePatterns(content, jsonParams));
    };

    const fetchPaginas = async () => {
      setLoading(true)
      try {
          const response = await PlantillaService.GetPaginasDestino();
          // console.log(response);
          setPages(response);
      } catch (error) {
          console.error(error)
      } finally {
          setLoading(false)
      }
    }

    const fetchPlantillas = async () => {
      setLoading(true)
      try {
          const response = await PlantillaService.GetPlantillas();
          setRows(PlantillaService.CreateFilas(response));
          console.log(response);
      } catch (error) {
          console.error(error)
      } finally {
          setLoading(false)
      }
    }

    useEffect(() => {
      fetchPaginas();
      fetchPlantillas();
    }, []);

    function fillForm(plantilla: Plantilla){
      setEditedPlantilla(plantilla);
      setTitle(plantilla.titulo);
      setContent(plantilla.contenido);
      setDesc(plantilla.descripcion);
      setPage(plantilla.paginaDestino);
      setFileName(plantilla.nombreImagen ?? "");
      setUrlImg(plantilla.urlImagen);
      setShowModal(plantilla.mostraModal);
      setAction(plantilla.accion);
      setUrl(plantilla.urlWeb);
      setUrlRec(plantilla.urlRecuperacion);
      setUrlVer(plantilla.urlVerificacion);
    };

    function setPlantillaValues(estado: string){
      setEditedPlantilla(
        new Plantilla(
          justCreating ? "0" : editedPlantilla.id!,
          "29",
          title ?? "",
          content ?? "",
          desc ?? "",
          page ?? "",
          fileName ?? "",
          urlImg ?? "",
          showModal,
          action,
          url ?? "",
          urlVer ?? "",
          urlRec ?? "",
          estado,
          new Date().toISOString(),
          "N"
        )
      )
    }

    async function editPlantilla(): Promise<void>{
      setPlantillaValues("A");
      await PlantillaService.EditPlantilla(editedPlantilla, newImage ? baseString ?? "" : "", userData.usuario);
    }

    async function createPlantilla(): Promise<void>{
      setPlantillaValues("A");
      await PlantillaService.PostNuevaPlantilla(editedPlantilla, baseString ?? "", userData.usuario);
    }

    function testPlantilla(): void{
      console.log(editedPlantilla);
      setPlantillaValues("I");
      PlantillaService.TestNuevaPlantilla(editedPlantilla, baseString ?? "", userData.usuario);
    }

    function didClose(){
      setStep(0);
      setTitle('');
      setContent('');
      setDesc('');
      setFileName(null);
      setUrlImg(null);
      setShowModal(false);
      setPage('');
      setUrl('');
      setAction('');
      setUrlVer('');
      setUrlRec('');
      setIsOpen(false)
      setJustCreating(false);
      setJustEditing(false);
      setJustLook(false);
      setShowJson(false);
      setShowJsonButton(false);
      setNewImage(false);
    }
    
    const paginatedRows = rows.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);
      
      return (
        <div>
          <Container maxWidth="lg" style={{ marginTop: 10, padding: '10px', textAlign: 'right', marginLeft: '15vw', }}>
            <Box sx={{ display: 'flex' }}>
              <Typography
                variant="h6"
                gutterBottom
                style={{
                  paddingBottom: '1%',
                  color: `${themePalette.BONDIBLUE}`,
                  fontSize: '1.25rem', // Custom size
                }}
              >
                PLANTILLAS
              </Typography>
            </Box>
            <Button
              variant="outlined"
              endIcon={<FaPlusCircle />}
              style={{
                color: `${themePalette.BONDIBLUE}`, 
                borderColor: `${themePalette.BONDIBLUE}`, 
                textTransform: 'none', // Prevent uppercase transformation
                borderRadius: '50px', // Circular borders
                padding: '5px 20px', 
                marginLeft: '10vw'
              }}
              onClick={() => {
                  setIsOpen(true);
                  setJustCreating(true);
                }
              }
            >
              Crear
            </Button>
          </Container>
          <Container maxWidth="lg" style={{ marginTop: 10, marginLeft: '15vw', marginRight: '30vw', padding: '20px', textAlign: 'center', border: `1px solid ${themePalette.BONDIBLUE}`, borderRadius: '5px' }}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ backgroundColor: themePalette.BONDIBLUE }}>
                    <TableCell align="center" sx={{ color: 'white' }}>Alias</TableCell>
                    <TableCell align="center" sx={{ color: 'white' }}>Contenido</TableCell>
                    <TableCell align="center" sx={{ color: 'white' }}>Titulo</TableCell>
                    <TableCell align="center" sx={{ color: 'white' }}>Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedRows.map((row) => (
                    <TableRow
                      key={row.alias+"-"+row.plantilla.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell 
                        component="th" 
                        scope="row" 
                        align="center" 
                        sx={{ fontSize: "0.8rem", width:"20vw", textAlign:"left"}}
                      >
                            {row.alias}
                      </TableCell>
                      <TableCell align="center" sx={{fontSize:"0.8rem", width:"25vw", textAlign:"left"}}>
                        {row.contenido}
                      </TableCell>
                      <TableCell align="center" sx={{fontSize:"0.8rem", width:"10vw", textAlign:"left"}}>
                        {row.titulo}
                      </TableCell>
                      <TableCell align="center" sx={{fontSize:"0.8rem", width:"10vw"}}>
                        <IconButton sx={{color: themePalette.BONDIBLUE}} aria-label="peek" onClick={() => {
                              console.log("Peek action")
                              setJustLook(true);
                              fillForm(row.plantilla);
                              setIsOpen(true);
                            }
                          }
                        >
                          <FaEye />
                        </IconButton>
                        <IconButton sx={{color: themePalette.BONDIBLUE}} aria-label="edit" onClick={() => {
                              setJustEditing(true);
                              console.log("Edit action: "+justEditing.toString())
                              fillForm(row.plantilla)
                              console.log(row.plantilla);
                              setIsOpen(true)
                            }
                          }
                        >
                          <FaEdit />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={pageNumber}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página"
                labelDisplayedRows={({ from, to, count }) => 
                  `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`
                }
                nextIconButtonProps={{
                  sx: { 
                    color: themePalette.BONDIBLUE, // Active color
                    "&.Mui-disabled": { color: "#A0A0A0" } // Disabled color (gray)
                  }
                }}
                backIconButtonProps={{
                  sx: { 
                    color: themePalette.BONDIBLUE, // Active color
                    "&.Mui-disabled": { color: "#A0A0A0" } // Disabled color (gray)
                  }
                }}
              />
            </TableContainer>
          </Container>


          <Modal open={isOpen} onClose={() => {
                didClose()
              }
            }>
            <Box sx={{
              display: "flex",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "75vw",
              height: "80vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              overflow: "auto",
              p: 4,
            }}>
              <button
                style={{
                  position: "sticky",
                  top: 0,
                  right: 0,
                  background: "transparent",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                  zIndex: 10, // Ensures it stays above content
                  alignSelf: "flex-end", // Aligns it to the top right
                  padding: "10px",
                }}
                onClick={() => {
                  didClose()
                }}
              >
                ✖
              </button>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {step==0 && (
                    <>
                      <Typography variant="h6" component="h2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Configuración básica
                      </Typography>
                      <FormControl margin="dense">
                        <Tooltip title="Este campo es para el título. Máximo 65 caracteres." arrow>
                          <span>
                            <FormLabel
                              id="titulo"
                              sx={{
                                display: 'flex',
                                alignItems: 'center', // Vertically center align
                                gap: '0.5rem', // Add spacing between label and icon
                                color: `${themePalette.GAINSBORO}`,
                                fontSize: '10px',
                                marginTop: '1vh', // Optional: adjust vertical spacing
                                '&.Mui-focused': {
                                  color: `${themePalette.GAINSBORO}`,
                                },
                              }}
                            >
                              Título
                                  <FaInfoCircle
                                    style={{
                                      marginTop:'2.5px',
                                      fontSize: '14px',
                                      color: `${themePalette.BONDIBLUE}`, // Icon color
                                      cursor: 'pointer',
                                    }}
                                  />
                            </FormLabel>
                          </span>
                        </Tooltip>

                        <TextField
                          fullWidth
                          disabled= {justLook}
                          margin="dense"
                          value={title}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            if(justEditing){
                              editedPlantilla?.setTitulo(event.target.value);
                            }
                            setTitle(event.target.value);
                            
                          }}
                          onBlur={() => {
                              // validateField('title', title ?? '')

                              if(title != null){
                                errors.title = (title.length > 65);
                              }
                            }
                          }
                          error={errors.title}
                          sx={{
                            width:'35vw',
                            color: `${themePalette.GAINSBORO}`
                          }}
                          helperText={errors.title ? 'Este campo es obligatorio' : ''}
                          multiline
                          rows={3}
                        />
                      </FormControl>
                      
                      <FormControl margin="dense">
                        <Tooltip title="Este campo es para el contenido. Máximo 300 caracteres." arrow>
                          <span>
                            <FormLabel 
                              id="content" 
                              sx={
                                  {
                                    display: 'flex',
                                    alignItems: 'center', // Vertically center align
                                    gap: '0.5rem', // Add spacing between label and icon
                                    color: `${themePalette.GAINSBORO}`,
                                    fontSize: '10px',
                                    marginTop: '1vh', // Optional: adjust vertical spacing
                                    '&.Mui-focused': {
                                      color: `${themePalette.GAINSBORO}`,
                                    },
                                  }
                                }
                              >
                              Contenido
                              <FaInfoCircle
                                style={{
                                  marginLeft:'5px',
                                  fontSize: '14px',
                                  color: `${themePalette.BONDIBLUE}`, // Icon color
                                  cursor: 'pointer',
                                }}
                              />
                            </FormLabel>
                          </span>
                        </Tooltip>
                        
                        <TextField
                          fullWidth
                          disabled= {justLook}
                          margin="dense"
                          value={content}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            if(justEditing){
                              editedPlantilla?.setContenido(event.target.value);
                            }
                            setContent(event.target.value);
                          }}
                          onBlur={() => {
                              // validateField('content', content ?? '')
                              if(content != null){
                                errors.content = (content.length > 300);
                              }
                            }
                          }
                          sx={{
                            width:'35vw',
                            color: `${themePalette.GAINSBORO}`
                          }}
                          error={errors.content}
                          helperText={errors.content ? 'Este campo es obligatorio' : ''}
                          multiline
                          rows={3}
                        />
                      </FormControl>
                      
                      <FormControl margin="dense">
                        <Tooltip title="Este campo es para la descripción. Máximo 100 caracteres." arrow>
                            <span>
                              <FormLabel 
                                id="desc" 
                                sx={
                                    {
                                      display: 'flex',
                                      alignItems: 'center', // Vertically center align
                                      gap: '0.5rem', // Add spacing between label and icon
                                      color: `${themePalette.GAINSBORO}`,
                                      fontSize: '10px',
                                      marginTop: '1vh', // Optional: adjust vertical spacing
                                      '&.Mui-focused': {
                                        color: `${themePalette.GAINSBORO}`,
                                      },
                                    }
                                  }
                                >
                                Descripcion
                                <FaInfoCircle
                                  style={{
                                    marginLeft:'5px',
                                    fontSize: '14px',
                                    color: `${themePalette.BONDIBLUE}`, // Icon color
                                    cursor: 'pointer',
                                  }}
                                />
                              </FormLabel>
                            </span>
                        </Tooltip>
                        
                        <TextField
                            fullWidth
                            disabled= {justLook}
                            margin="dense"
                            // label="Descripción"
                            value={desc}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                              if(justEditing){
                                editedPlantilla?.setDescripcion(event.target.value);
                              }
                              setDesc(event.target.value);
                            }}
                            onBlur={() => {
                                // validateField('desc', desc ?? '')
                                if(desc != null){
                                  errors.desc = (desc.length > 100);
                                }
                              }
                            }
                            error={errors.desc}
                            helperText={errors.desc ? 'Este campo es obligatorio' : ''}
                            sx={{
                              width:'35vw',
                              
                              color: `${themePalette.GAINSBORO}`
                            }}
                            multiline
                            rows={3}
                          />
                      </FormControl>
                      
                      <FormControl margin="dense" fullWidth>
                        <Tooltip title="Este campo es para la página a la que lleva la notificación." arrow>
                          <span>
                            <FormLabel 
                              id="endPage" 
                              sx={
                                  {
                                    display: 'flex',
                                    alignItems: 'center', // Vertically center align
                                    gap: '0.5rem', // Add spacing between label and icon
                                    color: `${themePalette.GAINSBORO}`,
                                    fontSize: '10px',
                                    marginTop: '1vh', // Optional: adjust vertical spacing
                                    marginBottom: '5px',
                                    '&.Mui-focused': {
                                      color: `${themePalette.GAINSBORO}`,
                                    },
                                  }
                                }
                              >
                              Página de destino
                              <FaInfoCircle
                                style={{
                                  marginLeft:'5px',
                                  fontSize: '14px',
                                  color: `${themePalette.BONDIBLUE}`, // Icon color
                                  cursor: 'pointer',
                                }}
                              />
                            </FormLabel>
                          </span>
                        </Tooltip>
                        
                        <Select
                          labelId="l-endPage"
                          disabled= {justLook}
                          id="endPage"
                          value={page}
                          // label="Página de destino"
                          onChange={handleChange}
                          // onBlur={() => {
                          //     validateField('page', page ?? '')
                          //   }
                          // }
                          error={errors.page}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: 200, // Set the dropdown height
                                overflowY: 'auto' // Enable scrolling if needed
                              }
                            }
                          }}
                        >
                          <MenuItem value=''>Ninguna</MenuItem>
                          {pages.map((item) =>(
                            <MenuItem value={item.value}>{item.label}</MenuItem>
                          ))}
                        </Select>
                        {errors.page && <FormHelperText error={errors.page}>Este campo es obligatorio</FormHelperText>}  {/* Show error message */}
                      </FormControl>
                      <Box display="flex" alignItems="center">
                        <FormControl margin="dense" fullWidth>
                          <Tooltip title="Este campo es para la imagen de la notificación." arrow>
                            <span>
                              <FormLabel 
                                id="image" 
                                sx={
                                    {
                                      display: 'flex',
                                      alignItems: 'center', // Vertically center align
                                      gap: '0.5rem', // Add spacing between label and icon
                                      color: `${themePalette.GAINSBORO}`,
                                      fontSize: '10px',
                                      marginTop: '1vh', // Optional: adjust vertical spacing
                                      marginBottom: '5px',
                                      '&.Mui-focused': {
                                        color: `${themePalette.GAINSBORO}`,
                                      },
                                    }
                                  }
                                >
                                Imagen
                                <FaInfoCircle
                                  style={{
                                    marginLeft:'5px',
                                    fontSize: '14px',
                                    color: `${themePalette.BONDIBLUE}`, // Icon color
                                    cursor: 'pointer',
                                  }}
                                />
                              </FormLabel>
                            </span>
                          </Tooltip>
                            
                          <TextField
                            // label= {fileName!=null ? "" : "Imagen"}
                            fullWidth
                            value={fileName}
                            // error={errors.fileName}
                            disabled= {justLook}
                            // helperText={errors.fileName ? 'Este campo es obligatorio' : ''}
                            // onBlur={() => validateField('fileName', fileName ?? '')}
                            InputProps={{
                              endAdornment: (
                                <IconButton component="label">
                                  <input type="file" hidden onChange={handleFileChange} />
                                  <FaUpload />
                                </IconButton>
                              ),
                            }}
                          />
                        </FormControl>
                      </Box>
                    </>
                  )}
                  
                  {step == 1 && (
                    <>
                      <Typography variant="h6" component="h2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Reglas de presentación
                      </Typography>
                      <FormControl margin="dense">
                        <FormLabel id="showModal">Mostrar como modal: </FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="showModal"
                            name="row-radio-show-modal"
                            onBlur={() => validateField('showModal', showModal.toString() ?? '')}
                          >
                            <FormControlLabel 
                              disabled= {justLook} 
                              checked={showModal} 
                              onClick={() => {
                                  {
                                    setShowModal(true) 
                                    editedPlantilla?.setMostraModal(true);
                                  }
                                }
                              } 
                              value={true} 
                              control={<Radio sx={{
                                color: `${themePalette.GAINSBORO}`,
                                '&.Mui-checked': {
                                  color: `${themePalette.BONDIBLUE}`, // Color when selected
                                },
                              }} />} 
                              label="Sí" 
                            />
                            <FormControlLabel 
                              disabled= {justLook} 
                              checked={!showModal} 
                              onClick={() => { 
                                  {
                                    setShowModal(false)
                                    editedPlantilla?.setMostraModal(false);
                                  }
                                }
                            } 
                              value={false}  
                              control={<Radio sx={{
                                color: `${themePalette.GAINSBORO}`,
                                '&.Mui-checked': {
                                  color: `${themePalette.BONDIBLUE}`, // Color when selected
                                },
                              }} />} 
                              label="No" 
                            />
                          </RadioGroup>
                          {errors.showModal && <FormHelperText error={errors.showModal}>Este campo es obligatorio</FormHelperText>}
                        </FormControl>
                        { showModal && (
                          <FormControl margin="dense" fullWidth>
                            <Tooltip title="Este campo es para la acción que realiza el botón dentro del modal." arrow>
                              <FormLabel
                                id="action"
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center', // Vertically center align
                                  gap: '0.5rem', // Add spacing between label and icon
                                  color: `${themePalette.GAINSBORO}`,
                                  fontSize: '10px',
                                  marginTop: '1vh', // Optional: adjust vertical spacing
                                  marginBottom: '5px',
                                  '&.Mui-focused': {
                                    color: `${themePalette.GAINSBORO}`,
                                  },
                                }}
                              >
                                Acción
                                <FaInfoCircle
                                  style={{
                                    fontSize: '14px',
                                    color: `${themePalette.BONDIBLUE}`, // Icon color
                                    cursor: 'pointer',
                                  }}
                                />
                              </FormLabel>
                            </Tooltip>
                          
                          <Select
                            disabled= {justLook}
                            // labelId="action"
                            id="action"
                            value={action}
                            // label="Accion"
                            error={errors.action}
                            onBlur={() => validateField('action', action ?? '')}
                            onChange={handleChangeAction}
                          >
                            <MenuItem value=''>Ninguna</MenuItem>
                            <MenuItem value='webPage'>Abrir página web</MenuItem>
                          </Select>
                          {errors.action && <FormHelperText error={errors.action}>Este campo es obligatorio</FormHelperText>}
                        </FormControl>
                      )}
                      { (showModal && action == 'webPage') && (
                        <FormControl margin="dense" fullWidth>
                          <Tooltip title="Este campo es para especificar la url de la página a la que lleva el botón del modal." arrow>
                            <span>
                              <FormLabel 
                                id="urlAction" 
                                sx={
                                    {
                                      display: 'flex',
                                      alignItems: 'center', // Vertically center align
                                      gap: '0.5rem', // Add spacing between label and icon
                                      color: `${themePalette.GAINSBORO}`,
                                      fontSize: '10px',
                                      marginTop: '1vh', // Optional: adjust vertical spacing
                                      marginBottom: '5px',
                                      '&.Mui-focused': {
                                        color: `${themePalette.GAINSBORO}`,
                                      },
                                    }
                                  }
                              >
                                Url de acción
                                <FaInfoCircle
                                  style={{
                                    marginLeft:'5px',
                                    fontSize: '14px',
                                    color: `${themePalette.BONDIBLUE}`, // Icon color
                                    cursor: 'pointer',
                                  }}
                                />
                              </FormLabel>
                            </span>
                          </Tooltip>
                          <TextField
                            disabled= {justLook}
                            // label="Url de acción"
                            fullWidth
                            value={url}
                            error={errors.url}
                            helperText={errors.url ? 'Este campo es obligatorio' : ''}
                            onBlur={() => {
                                validateField('url', url ?? '')
                                if(!errors.url && url != null){
                                  errors.url = (url.length === 255);
                                } 
                              }
                            }
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                              if(justEditing){
                                editedPlantilla?.setUrlWeb(event.target.value);
                              }
                              setUrl(event.target.value);
                            }}
                          />
                        </FormControl>
                        
                      )}
                    </>
                  )}
                  {step == 2 && (
                    <>
                      <Typography variant="h6" component="h2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        Configuración Avanzada
                      </Typography>
                      <FormControl margin="dense" fullWidth>
                        <Tooltip title="Ingrese url de verificación previo envío de notificación." arrow>
                          <span>
                            <FormLabel 
                              id="urlVer" 
                              sx={
                                  {
                                    display: 'flex',
                                    alignItems: 'center', // Vertically center align
                                    gap: '0.5rem', // Add spacing between label and icon
                                    color: `${themePalette.GAINSBORO}`,
                                    fontSize: '10px',
                                    marginTop: '1vh', // Optional: adjust vertical spacing
                                    marginBottom: '5px',
                                    '&.Mui-focused': {
                                      color: `${themePalette.GAINSBORO}`,
                                    },
                                  }
                                }
                              >
                              Url de verificación
                              <FaInfoCircle
                                style={{
                                  marginLeft:'5px',
                                  fontSize: '14px',
                                  color: `${themePalette.BONDIBLUE}`, // Icon color
                                  cursor: 'pointer',
                                }}
                              />
                            </FormLabel>
                          </span>
                        </Tooltip>
                        
                        <TextField
                          disabled= {justLook}
                          fullWidth
                          value={urlVer}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            if(justEditing){
                              editedPlantilla?.setUrlVerificacion(event.target.value);
                            }
                            setUrlVer(event.target.value);
                          }}
                        />
                      </FormControl>

                      <FormControl margin="dense" fullWidth>
                        <Tooltip title="Este campo es para especificar la url para recuperar datos dinámicos de la plantilla." arrow>
                            <span>
                              <FormLabel 
                                id="urlRec" 
                                sx={
                                    {
                                      display: 'flex',
                                      alignItems: 'center', // Vertically center align
                                      gap: '0.5rem', // Add spacing between label and icon
                                      color: `${themePalette.GAINSBORO}`,
                                      fontSize: '10px',
                                      marginTop: '1vh', // Optional: adjust vertical spacing
                                      marginBottom: '5px',
                                      '&.Mui-focused': {
                                        color: `${themePalette.GAINSBORO}`,
                                      },
                                    }
                                  }
                                >
                                Url de recuperación de datos dinámicos
                                <FaInfoCircle
                                  style={{
                                    marginLeft:'5px',
                                    fontSize: '14px',
                                    color: `${themePalette.BONDIBLUE}`, // Icon color
                                    cursor: 'pointer',
                                  }}
                                />
                              </FormLabel>
                            </span>
                        </Tooltip>
                        
                        <TextField
                          disabled= {justLook}
                          fullWidth
                          value={urlRec}
                          onBlur={() => {
                            if(!justLook){
                              if(urlRec == null){
                                setShowJsonButton(false);
                                setShowJson(false);
                              }
                              else if(urlRec!.length >= 60){
                                console.log("habilitado");
                                setShowJsonButton(true);
                              }else{
                                setShowJsonButton(false);
                                setShowJson(false);
                              }
                            }
                          }}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            if(justEditing){
                              editedPlantilla?.setUrlRecuperacion(event.target.value);
                            }
                            setUrlRec(event.target.value);
                            if(!justLook){
                              if(urlRec != null){
                                if(urlRec.length > 10){
                                  setShowJsonButton(true);
                                }
                              }else{
                                setShowJsonButton(false);
                                setShowJson(false);
                              }
                            }
                          }}
                        />
                      </FormControl>
                      {(showJsonButton) && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                              console.log("Trying "+urlRec!.trim());
                              const datosDim = await PlantillaService.ValidateDatosPlantilla(urlRec!);
                              console.log("Output "+JSON.stringify(datosDim));
                              
                              //parametros iniciales
                              setJsonParams(datosDim);
                              setShowJson(true);
                              setJsonData(datosDim);
                            }}
                            sx={{
                              backgroundColor: `${themePalette.BONDIBLUE}`,
                              '&:hover': {
                                backgroundColor: `${themePalette.BONDIBLUE}`, // Keep hover consistent
                                opacity: 0.9,
                              },
                            }}
                          >
                            Validar
                          </Button>
                        </Box>
                      )}
                    </>
                  )}

                  {(step == 3) && (
                    <>
                      <FormControl margin="dense">
                        <Tooltip title="Este campo es para el contenido. Máximo 300 caracteres." arrow>
                          <span>
                            <FormLabel 
                              id="content" 
                              sx={
                                  {
                                    display: 'flex',
                                    alignItems: 'center', // Vertically center align
                                    gap: '0.5rem', // Add spacing between label and icon
                                    color: `${themePalette.BONDIBLUE}`,
                                    fontSize: '14px',
                                    marginTop: '1vh', // Optional: adjust vertical spacing
                                    '&.Mui-focused': {
                                      color: `${themePalette.BONDIBLUE}`,
                                    },
                                  }
                                }
                              >
                              Contenido
                              <FaInfoCircle
                                style={{
                                  marginLeft:'5px',
                                  fontSize: '14px',
                                  color: `${themePalette.BONDIBLUE}`, // Icon color
                                  cursor: 'pointer',
                                }}
                              />
                            </FormLabel>
                          </span>
                        </Tooltip>
                        
                        <TextField
                          fullWidth
                          disabled= {justLook}
                          margin="dense"
                          value={content}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            if(justEditing){
                              editedPlantilla?.setContenido(event.target.value);
                            }
                            setContent(event.target.value);
                            checkContentVariables();
                          }}
                          onBlur={() => {
                              // validateField('content', content ?? '')
                              if(content != null){
                                errors.content = (content.length > 300);
                              }

                              if(!errors.content){
                                checkContentVariables();
                              }
                            }
                          }
                          sx={{
                            width:'35vw',
                            color: `${themePalette.GAINSBORO}`
                          }}
                          error={errors.content}
                          helperText={errors.content ? 'Este campo es obligatorio' : ''}
                          multiline
                          rows={3}
                        />
                      </FormControl>

                      <FormLabel 
                        sx={
                            { 
                              display: 'flex',
                              alignItems: 'center', // Vertically center align
                              gap: '0.5rem', // Add spacing between label and ico
                              color: `${themePalette.BONDIBLUE}`,
                              fontSize: '14px',
                              fontWeight: 'normal',
                              marginTop: '1vh', // Optional: adjust vertical spacing
                              marginBottom: '1vh',
                              '&.Mui-focused': {
                                color: `${themePalette.BONDIBLUE}`,
                              }, 
                            }
                          }>
                        Parámetros de contenido
                      </FormLabel>
                      <Card variant="outlined" sx={{ width: '35vw'}}>
                        <CardContent>
                          <Box sx={{ display: 'flex', flexDirection:'row', gap: 2}}>
                            <Box width={'5vw'}>
                              <Typography variant="caption">
                                Variable
                              </Typography >
                            </Box>
                            <Box width={'11vw'}>
                              <Typography variant="caption">
                                Nombre de parámetro
                              </Typography>
                            </Box>
                            <Box width={'5vw'}>
                              <Typography variant="caption">
                              Ejemplo
                              </Typography>
                            </Box>
                          </Box>
                          <ParametroList onParametrosChange={setJsonParams} onSuccesChange={checkContentVariables} parametrosIni={jsonParams!}></ParametroList>
                        </CardContent>
                      </Card>
                    </>
                  )}
                  
                </Grid>
                <Grid item>
                  {(step == 1 || (step == 2 && !showJson) || step == 3 ) && (
                    <Card sx={{ width: '32.5vw', marginBottom:'10px' }}>
                      <CardContent>
                      <Box sx={{ width: '32.5vw', display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h6" component="h2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            Vista previa del dispositivo
                            </Typography>
                            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                            En esta vista previa, se ofrece una idea general de cómo se mostrará tu mensaje en un 
                            dispositivo móvil. La apariencia real del mensaje varía en función del dispositivo. Para obtener resultados precisos, prueba con un dispositivo real. 
                            </Typography>
                            <Button
                                variant="outlined"
                                sx={{
                                    backgroundColor: '#0A2C6B', 
                                    '&:hover': { backgroundColor: '#082354' },
                                    width: '12.5vw',
                                    height: '5vh',
                                    marginBottom: '10px'
                                }}
                                onClick={() => {
                                  if(step == 1){ 
                                    if(showModal){
                                      console.log("showing modal");
                                      if(validateReglasPres()){
                                        console.log("validated, editing? "+justEditing+ " creating? "+justCreating);
                                        if(justCreating){
                                          console.log("creating test plantilla");
                                          testPlantilla()
                                        }else if(justEditing){
                                          testPlantilla()
                                        }
                                      }
                                    }else{
                                      if(justCreating){
                                        testPlantilla()
                                      }else if(justEditing){
                                        console.log(editedPlantilla);
                                        testPlantilla()
                                        
                                      }
                                    }
                                  }
                                }}
                            >
                            Notificacion de prueba
                            </Button>
                        </Box>
                      </CardContent>
                    </Card>
                    
                  )}
                  {(step == 0 || (step == 1 && showModal) || (step == 2 && showJson) || step == 3 ) && (
                    <>
                      <NotificationShow title={title} content={replacedContent ?? content} urlImg={urlImg ?? ""} jsonData={jsonData} showModal={showModal} showJson={showJson} step={step} ></NotificationShow>
                    </>
                  )}
                </Grid>
                <Box 
                  sx={{ 
                    position: 'sticky',
                    bottom: 0,
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    mt: 3, 
                    width: '100%', 
                    paddingLeft: '5vw',
                    border:'hidden',
                    paddingRight: 0 ,
                    zIndex: 10, // Keeps it above other elements
                    backgroundColor: 'transparent', // Make it transparent
                  }}
                >
                  {step > 0 && (
                    <Button
                      variant="outlined"
                      startIcon={<FaCaretLeft />}
                      style={{
                        color: themePalette.BONDIBLUE, 
                        borderColor: themePalette.BONDIBLUE,
                        textTransform: 'none',
                        borderRadius: '50px',
                        padding: '5px 20px',
                        width: '10vw',
                        height: '5vh'
                      }}
                      onClick={() => setStep(step - 1)}
                    >
                      Atrás
                    </Button>
                  )}

                  {(justLook && step == 2) && (
                    <Button 
                      type="submit" 
                      variant="contained" 
                      endIcon={<FaCaretRight />}
                      sx={{
                        ml: 2, 
                        backgroundColor: '#0A2C6B', 
                        '&:hover': { backgroundColor: '#082354' },
                        marginRight: '4vw',
                        width: '10vw',
                        height: '5vh'
                      }}
                      onClick={didClose}
                    >
                      Cerrar
                    </Button>
                  )}

                  {((justEditing && !showJson && step == 2) || (justEditing && showJson && step == 3)) && (
                    <Button 
                      type="submit" 
                      variant="contained" 
                      endIcon={<FaCaretRight />}
                      sx={{
                        ml: 2, 
                        backgroundColor: '#0A2C6B', 
                        '&:hover': { backgroundColor: '#082354' },
                        marginRight: '4vw',
                        width: '10vw',
                        height: '5vh'
                      }}
                      onClick={ async () => {
                        await editPlantilla();
                        didClose();
                      }}
                    >
                      Editar Plantilla
                    </Button>
                  )}

                  {((justCreating && !showJson && step == 2) || (justCreating && showJson && step == 3)) && (
                    <Button 
                      type="submit" 
                      variant="contained" 
                      endIcon={<FaCaretRight />}
                      sx={{
                        ml: 2, 
                        backgroundColor: '#0A2C6B', 
                        '&:hover': { backgroundColor: '#082354' },
                        marginRight: '4vw',
                        width: '10vw',
                        height: '5vh'
                      }}
                      onClick={ async () => {
                          await createPlantilla()
                          didClose();
                        }
                      }
                    >
                      Crear Plantilla
                    </Button>
                  )}  

                  {((showJson && step == 2 && !justLook) || (step < 2)) && (
                    <Button 
                      type="submit" 
                      variant="contained" 
                      endIcon={<FaCaretRight />}
                      sx={{
                        ml: 2, 
                        backgroundColor: '#0A2C6B', 
                        '&:hover': { backgroundColor: '#082354' },
                        marginRight: '4vw',
                        width: '10vw',
                        height: '5vh'
                      }}
                      onClick={() => {
                        if (justLook) setStep(step + 1);
                        if (validateBasicConfig() && step == 0) setStep(1);
                        if ((validateReglasPres() && step == 1) || (!showModal && step == 1)) setStep(2);
                        if (step == 2) setStep(3);
                      }}  
                    >
                      Siguiente
                    </Button>
                  )}
                </Box>
              </Grid>
              
            </Box>
          </Modal>
        </div>
      );
};